import { Box, Card, CardContent, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import CardComp from "shared/components/card";
import { toastMessage } from "shared/components/toast";
import useBreadcrumbs from "shared/customHooks/useBreadCrumbs";
import { routeConstant } from "shared/routes/routesConstant";
import { getAnalyticsDevices } from "shared/services/productManagerService";
import styles from "./style.module.scss";

function AppAnalyticsDevices() {
  const [loading, setLoading] = useState<boolean>(false);
  const [analyticsData, setAnalyticsData] = useState<any>(null);

  useBreadcrumbs([
    {
      label: routeConstant.dashboard.title,
      route: routeConstant.dashboard.path,
    },
    {
      label: routeConstant.appAnalytics.title,
      route: routeConstant.appAnalytics.path,
    },
    {
      label: routeConstant.appAnalyticsDevices.title,
      route: routeConstant.appAnalyticsDevices.path,
    },
  ]);

  const fetchDevicesData = () => {
    setLoading(true);
    getAnalyticsDevices()
      .then(({ data }) => {
        setAnalyticsData(data?.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log("err", err?.response?.data?.message);
        toastMessage("error", err?.response?.data?.message);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchDevicesData();
  }, []);

  const deviceTypeCards = [
    {
      title: "Phones",
      value: analyticsData?.device_types?.phones || 0,
    },
    {
      title: "Tablets",
      value: analyticsData?.device_types?.tablets || 0,
    },
    {
      title: "Emulators",
      value: analyticsData?.device_types?.emulators || 0,
    },
  ];

  return (
    <Box className={styles.container}>
      <Box className={styles.header}>
        <Typography variant="h4">Device Analytics</Typography>
      </Box>

      <Grid container spacing={3} className={styles.statsContainer}>
        {deviceTypeCards.map((card, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <CardComp
              title={card.title}
              stats={card.value}
              isLoading={loading}
            />
          </Grid>
        ))}
      </Grid>

      <Grid container spacing={3} className={styles.chartContainer}>
        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Devices by Platform
              </Typography>
              {analyticsData?.by_platform && (
                <Box className={styles.platformStats}>
                  {analyticsData.by_platform.map((item: any) => (
                    <Box key={item.platform} className={styles.platformItem}>
                      <Typography variant="body1">
                        {item.platform.toUpperCase()}
                      </Typography>
                      <Typography variant="body1" fontWeight="bold">
                        {item.count}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              )}
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Devices by App Version
              </Typography>
              {analyticsData?.by_app_version && (
                <Box className={styles.versionStats}>
                  {analyticsData.by_app_version.slice(0, 10).map((item: any) => (
                    <Box key={item.app_version} className={styles.versionItem}>
                      <Typography variant="body1">
                        v{item.app_version}
                      </Typography>
                      <Typography variant="body1" fontWeight="bold">
                        {item.count}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              )}
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12}>
          <Card>
            <CardContent>
              <Typography variant="h6" gutterBottom>
                Devices by OS Version
              </Typography>
              {analyticsData?.by_os_version && (
                <Box className={styles.osVersionContainer}>
                  {analyticsData.by_os_version.slice(0, 15).map((item: any, index: number) => (
                    <Box key={index} className={styles.osVersionItem}>
                      <Typography variant="body2">
                        {item.platform.toUpperCase()} {item.platform_version}
                      </Typography>
                      <Typography variant="body2" fontWeight="bold">
                        {item.count}
                      </Typography>
                    </Box>
                  ))}
                </Box>
              )}
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}

export default AppAnalyticsDevices;
